import {computed, inject, Injectable, Signal} from '@angular/core';
import {ApolloQueryResult} from '@apollo/client/core';
import {Query, StoreConfig} from '@core/interfaces/generated/graphql';
import {ApolloService} from '@core/services/apollo.service';

@Injectable({
  providedIn: 'root'
})
export class StoreConfigService {
  private apollo = inject(ApolloService);

  currencyCode = computed(() => {
    return this.storeConfig()?.currencyCode;
  });

  protected _storeConfigResult: Signal<ApolloQueryResult<Query> | undefined> = this.apollo.watchQuerySignal<Query>({
    queryName: 'getStoreConfig',
  });

  protected _storeConfig = computed(() => {
    return this._storeConfigResult()?.data.getStoreConfig;
  })

  get storeConfig(): Signal<StoreConfig | undefined> {
    return this._storeConfig;
  }

}
